import { render } from "./RequestsPrint.vue?vue&type=template&id=59d37446"
import script from "./RequestsPrint.vue?vue&type=script&lang=js"
export * from "./RequestsPrint.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__